import React from 'react';
import { Box, Typography } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';

export const PASSWORD_RULES = [
  { key: 'minLength', test: (p) => p.length >= 9 },
  { key: 'uppercase', test: (p) => /[A-Z]/.test(p) },
  { key: 'lowercase', test: (p) => /[a-z]/.test(p) },
  { key: 'number', test: (p) => /[0-9]/.test(p) },
  { key: 'special', test: (p) => /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(p) },
];

export const passwordRulesPass = (password) =>
  password.length > 0 && PASSWORD_RULES.every(({ test }) => test(password));

export const PasswordChecklist = ({ password, t }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 1, mb: 0.5 }}>
    {PASSWORD_RULES.map(({ key, test }) => {
      const ok = test(password);
      return (
        <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Box sx={{ width: 14, height: 14, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {ok && <CheckIcon color="success" sx={{ fontSize: 14 }} />}
          </Box>
          <Typography variant="caption" color={ok ? 'success.main' : 'text.secondary'}>
            {t(`changePassword.rules.${key}`)}
          </Typography>
        </Box>
      );
    })}
  </Box>
);
